import "../styles/globals.css";
import { useState } from "react";
import type { AppProps } from "next/app";
import { Hydrate, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MainLayout from "layouts/MainLayout";
import exception from "utils/exception";
import Alert from "components/General/Alert";
import { appWithTranslation } from "next-i18next";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useRouter } from "next/router";
interface AppPropsProperties extends AppProps {
  pageProps: any;
}

function MyApp({ Component, pageProps }: AppPropsProperties) {
  const { push, pathname } = useRouter();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            staleTime: Infinity,
            retryDelay: (attemptIndex) => 1000 * Math.pow(2, attemptIndex),
            onError: (error: any) => {
              if (error.request.status === 404) {
                pathname.includes("research") ? push("/research") : push("/");
              }
            },
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={pageProps.dehydratedState}>
        <Alert ref={exception.snackBarRef} />
        <MainLayout Component={Component} pageProps={pageProps} />
        <ReactQueryDevtools />
      </Hydrate>
    </QueryClientProvider>
  );
}

export default appWithTranslation(MyApp);
